import { render } from "./WeComLogin.vue?vue&type=template&id=80d7adb2&scoped=true"
import script from "./WeComLogin.vue?vue&type=script&lang=js"
export * from "./WeComLogin.vue?vue&type=script&lang=js"

import "./WeComLogin.vue?vue&type=style&index=0&id=80d7adb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80d7adb2"]])

export default __exports__